export const urlParamsToMap = (str) => {
    const url = new URL(str);
    if (!url.search) {
        return new Map();
    }
    return new Map([url.search.replace(/^\?/, "").split("=")]);
};
